import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 50px 24px;
  @media ${DEVICES.sm} {
    padding: 0;
    height: auto;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  @media ${DEVICES.sm} {
    margin-bottom: 32px;
    padding: 16px 16px 0 16px;
  }
`;

export const MainFormWrapper = styled.div`
  padding: 28px;
  display: flex;
  overflow: auto;
  align-items: center;
  @media ${DEVICES.sm} {
    padding: 28px 16px 16px 16px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-width: 1200px;
  max-height: 100%;
  .ant-btn {
    padding: 9px 40px;
    border-radius: 4px;
  }
`;

export const FormTitle = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const FormSubtitle = styled.div`
  display: flex;
  margin-bottom: 24px;
  max-width: 498px;
`;

export const GreyLine = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.grayVariations.light};
  height: 100%;
  width: 2px;
  @media ${DEVICES.sm} {
    height: 2px;
    width: 100%;
    margin-top: 8px;
  }
`;

export const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-self: center;
  background: ${({ theme }) => theme.colors.primary.white};
  border-radius: 10px;
  @media ${DEVICES.sm} {
    flex-direction: column;
    min-height: calc(100vh - 44px);
  }
`;

export const StepsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  & > div {
    height: 100%;
    max-height: 296px;
    width: 184px;
    display: flex;
    .ant-steps-item-process
      > .ant-steps-item-container
      > .ant-steps-item-content
      > .ant-steps-item-title {
      color: ${({ theme }) => theme.colors.primary.blue};
    }
    .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
      font-size: 14px;
    }
  }
  @media ${DEVICES.sm} {
    padding: 0 16px;
    & > div {
      height: 100%;
      max-height: 100%;
      width: 100%;
      .ant-steps-item-icon {
        margin: 0;
      }
    }
  }
`;

export const FormItemContainer = styled.div`
  display: flex;
  ${({ itemWidth }: { itemWidth?: number }) =>
    itemWidth ? `width: ${itemWidth}px;` : `width: 288px;`};
  .ant-form-item {
    width: 100%;
  }
  @media ${DEVICES.sm} {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const ThanksContainer = styled.div`
  display: flex;
  align-self: center;
  text-align: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  justify-items: center;
  & > div {
    display: flex;
    flex-direction: column;
    max-width: 500px;
    justify-content: center;
    align-items: center;
    .subtitle {
      margin-bottom: 24px;
    }
  }
  @media ${DEVICES.sm} {
    height: calc(100vh - 44px);
  }
`;
